import React from 'react'
import './style.scss'

const CreditFooter = () => (
  <div className='footer_credit'>
    <div className='footer_credit_message'>
      <div className='footer_credit_title'>VAMOS CONVERSAR?</div>
      <div className='footer_credit_text'>contato@mellro.com</div>
      <div className='footer_credit_text'>(41) 98788-9368</div>
    </div>

    <div className='footer_credit_message'>
      <div className='footer_credit_title'>ONDE ESTAMOS:</div>
      <div className='footer_credit_text'>Fazemos o Mellro com carinho em Curitiba</div>
    </div>
    <div className='footer_credit_copyright'>
      <div className='footer_credit_content'>
        <div className='footer_credit_text'>© 2020 Mellro All Rights Reserved</div>
      </div>
    </div>
  </div>
)

export default CreditFooter
